import { Component, OnInit } from '@angular/core';
import {
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { RuleInterface } from '@vendasta/automata';
import { CommonActionPanelComponent } from '../../../common/common-action-panel-component.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';

interface Value {
  id: string;
  direction: string;
}
interface LabelId {
  label: string;
  value: Value;
}

export const options: LabelId[] = [
  {
    label: 'AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.NEWEST_OPPORTUNITY',
    value: { id: 'created_date', direction: 'desc' },
  },
  {
    label: 'AUTOMATIONS.EDITOR.TASKS.QUERY_OPPORTUNITIES.OLDEST_OPPORTUNITY',
    value: { id: 'created_date', direction: 'asc' },
  },
];

@Component({
  selector: 'automata-query-opportunities-panel',
  templateUrl: './query-opportunities-panel.component.html',
  styleUrls: ['./query-opportunities-panel.component.scss'],
  imports: [
    CommonModule,
    TranslateModule,
    GalaxyAlertModule,
    MatButtonModule,
    MatCardModule,
    FormsModule,
    GalaxyFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
  ],
})
export class QueryOpportunitiesPanelComponent extends CommonActionPanelComponent implements OnInit {
  options: LabelId[] = options;

  optionsFormControl: FormControl<Value> = new FormControl<Value>(null, Validators.required);

  ngOnInit(): void {
    super.ngOnInit();
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    const value = { id: jsonData.sort_field, direction: jsonData.sort_direction };
    this.optionsFormControl.setValue(value);
    this.savingEnabled = true;
  }

  getRules(): RuleInterface[] {
    return [];
  }

  getData(): any {
    const jsonData = this.step ? JSON.parse(this.step.data) : {};
    const selectedOption = this.optionsFormControl.value;
    jsonData.sort_field = selectedOption.id;
    jsonData.sort_direction = selectedOption.direction;
    return jsonData;
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.optionsFormControl];
  }

  isFormValid(): boolean {
    return !this.optionsFormControl.invalid;
  }

  compareOptions(s1: Value, s2: Value): boolean {
    return s1?.id === s2?.id && s1?.direction === s2?.direction;
  }
}
